export function setCookie (key, val, days, path, domain) {
  // export function setCookie (key, val, days, path, domain = '192.168.0.136') {
  let expire = new Date()
  expire.setTime(
    expire.getTime() +
    (days ? 3600000 * 24 * days : 30 * 24 * 60 * 60 * 1000)
  ) // 默认1个月
  document.cookie =
    key +
    '=' +
    encodeURIComponent(val) +
    ';expires=' +
    expire.toGMTString() +
    ';' +
    (domain ? 'domain=' + domain + ';' : '')
}

export function getCookie (key) {
  let r = new RegExp('(?:^|;+|\\s+)' + key + '=([^;]*)')
  let m = window.document.cookie.match(r)
  let rs = !m ? '' : m[1]
  return decodeURIComponent(rs)
}

export function delCookie (key, domain) {
  document.cookie =
    key +
    '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;' +
    (domain ? 'domain=' + domain + ';' : '')
}

export function insertScript (src, onload, async, id) {
  let head = document.getElementsByTagName('head')[0]
  let script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = src
  script.onload = function () { onload && onload(script) }
  script.async = async || false
  if (id) {
    script.setAttribute('id', id)
  }
  head.appendChild(script)
}

export function myJsonp (url, data, callback)  {
  var fnName = 'myJsonp_' + Math.random().toString().replace('.','');
  //定义一个全局回调函数
  window[fnName] = callback;
  //初始化序列化参数
  var querystring = '';
  for(var attr in data) {
    querystring += attr + '=' + data[attr] + '&'
  }
  //动态创建script标签
  var script = document.createElement('script')
  //后台接受回调函数，并调用
  script.src = url + '?' + querystring + 'callbackjsonp=' + fnName
  
  //处理完毕之后,删除script标签，否则多次请求，页面会存在多个script标签
  script.onload = function() {    
    document.body.removeChild(script)
  }
  document.body.appendChild(script)
}

export function isIOS () {
  return /iphone|ipad/i.test(navigator.userAgent)
}

export function copy (text, dom = document.body) {
  return new Promise((resolve, reject) => {
    if (!document.queryCommandSupported('copy')) {
      reject(new Error())
      return
    }
    let container = dom || document.body
    const input = document.createElement('input')
    input.setAttribute('readonly', 'readonly')
    input.setAttribute('value', text)
    container.appendChild(input)
    input.select()
    input.setSelectionRange(0, ('' + text).toString().length)
    try {
      var successful = document.execCommand('copy')
      dom.removeChild(input)
      if (successful) {
        resolve()
      } else {
        reject(new Error())
      }
    } catch (err) {
      dom.removeChild(input)
      reject(err)
    }
  })
}

export function transferBytes (file) {
  return new Promise((resolve, reject) => {
    try {
      let reader = new FileReader()
      let fileByteArray = []
      reader.readAsArrayBuffer(file)
      reader.onloadend = function (evt) {
        if (evt.target.readyState === FileReader.DONE) {
          let arrayBuffer = evt.target.result
          let array = new Uint8Array(arrayBuffer)
          for (var i = 0; i < array.length; i++) {
            fileByteArray.push(array[i])
          }
          resolve(fileByteArray)
        }
      }
    } catch (err) {
      reject(err)
    }
  })
}
// 将base64转换为文件
export function dataURLtoFile (dataurl, filename) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

/**
 * 图片水印支持
 * @export
 * @param {*} file 文件对象
 * @param {*} text 文字
 * @param {*} url 原始图片，（文件对象 与原始图片 二选一）
 * @returns
 */
export function watermark (file, text, url = '') {
  return new Promise((resolve, reject) => {
    try {
      if (!url && !file) throw new Error('缺少参数')
      const rotate = function (target) {
        var context = target.getContext('2d')
        var metrics = context.measureText(text)
        var x = (target.width / 2) - (metrics.width + 40)
        var y = (target.height / 2) + 30 * 2
        context.translate(x, y)
        context.globalAlpha = 0.8
        context.fillStyle = '#FF3E90'
        context.font = '50px Josefin Slab'
        context.rotate(-30 * Math.PI / 180)
        context.fillText(text, 0, 0)
        return target
      }
      const draw = (path) => {
        const options = {
          init (img) {
            img.crossOrigin = 'anonymous'
            img.setAttribute('referrer', 'no-referrer')
          }
        }
        const watermark = require('watermarkjs')
        const name = file ? file.name : 'default.png'
        watermark([path], options)
          .image(rotate)
          .then(img => {
            resolve({
              file: dataURLtoFile(img.src, name),
              base64: img.src
            })
          })
      }
      if (url) return draw(url)

      if (file) {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          draw(this.result)
        }
      }
    } catch (err) {
      console.log('error===>', err)
      reject(err)
    }
  })
}


export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};